/** The maximum number of RegEx matches returned */
export const MAX_REGEX_MATCHES: number = 50;

/** The maximum length of a body for RegEx activation to run */
export const MAX_BODY_REGEX_ACTIVATION_LENGTH: number = 500000;

/** The maximum character length of a RegEx match */
export const MAX_REGEX_MATCH_LENGTH: number = 10 * 1024;
